import { dispatchActions, useUserDispatch, useUserState } from "contexts";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IUserActionsType } from "types";
import { useProject } from "./functions/useProject";
import { useMember } from "./functions/useMember";

export function useApp() {
    const { t } = useTranslation();
    const trans = (str) => t(str as string);
    const {
        dataMembers = [],
        dataTags = [],
        dataSprints = [],
        taskDetail = null,
        projectDetail = null,
        projectData = null,
        projectCurrentPage = 1,
        projectIsFetch = false,
        taskDetailIsFetch = false,
        taskFilter = {
            status: 'open'
        },
        userData = null,
        userCurrentPage = 1,
        userIsFetch = false
    } = useUserState() || {};

    const { getProjects } = useProject();
    const { getMembers } = useMember();

    const userDispatch = useUserDispatch();

    const onUpdateParams = useCallback(
        (payload: any) => {
            dispatchActions(
                { type: IUserActionsType.UPDATE_PARAMS, payload },
                userDispatch,
            );
        },
        [userDispatch],
    );

    const loadInitialData = async () => {
        try {
            const [projects, users] = await Promise.all([
                getProjects(projectCurrentPage),
                getMembers(userCurrentPage)
            ]);
            return { projects, users }
        } catch (error) {
            console.error("Lỗi load dữ liệu:", error);
        }
    }

    return {
        trans,
        loadInitialData,
        onUpdateParams,
        projectDetail,
        taskDetailIsFetch,
        projectData,
        projectCurrentPage,
        projectIsFetch,
        userData,
        userCurrentPage,
        userIsFetch,
        dataSprints,
        dataTags,
        dataMembers,
        taskDetail,
        taskFilter
    }
}
